export default __webpack_public_path__ + "static/media/ers.6e980d07.png";